import { useCallback } from "react";

interface DatalayerOptions {
    [key: string]: string;
    event: string;
    event_category: string;
    event_action: string;
    event_label: string;
    interaction: string;
    component_name: string;
    element_text: string;
}

export const useDatalayer = (campaign_description?: string) => {
    const defaultOptions: DatalayerOptions = {
        'event': 'GAEvent',
        'event_category': 'Content',
        'event_action': '',
        'event_label': '',
        'interaction': 'true',
        'component_name': '',
        'element_text': '',
        'campaign_description': '',
    }

    const pushDatalayer = useCallback((options: DatalayerOptions | Omit<DatalayerOptions, 'event' | 'interaction' | 'event_category'>) => {
        window.dataLayer.push({ ...defaultOptions, campaign_description, ...options });
    }, [])

    return { pushDatalayer }
}